@if (toastData) {
  <table rowHeight="27px" width="280px">
    <th class="text-nowrap justifyItems">
      <i>{{ getEventLevelIcon() }}</i>
      <div style="min-width: 180px; max-width: 180px; text-wrap: wrap">{{ toastData.summary }}</div>
      <!-- <div class="inlineClass">
      {{ toastData.summary.substr(0, 25) }}
      <div *ngIf="toastData.summary.length > 26" class="inlineClass">...</div>
    </div> -->
    </th>
    <th class="alignRight">
      @if (!isInProgress() && getEventStatusIcon().length > 0 && !(toastData.updateLabel?.length ?? 0 > 0)) {
        <span class="ebo-spacer">
          <i>{{ getEventStatusIcon() }}</i>
        </span>
      }
    </th>
    @if (toastData.urlLabel && toastData.urlLink) {
      <th>
        <p-button class="text-nowrap" (click)="navAndClear(toastData.urlLink)">
          {{ toastData.urlLabel }}
        </p-button>
      </th>
    }
  </table>
}
@if (isInProgress()) {
  <span>
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
  </span>
}
